// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"BadEmailOrPassword_errorMessage__2Pm0D","errMessage":"BadEmailOrPassword_errMessage__17o9z"};